import styled from 'styled-components';

import theme from '../../../../assets/theme';

const ProgressBarDynamicLesson = ({
  progress,
  numberOfSteps,
}: {
  progress: number; //This is percentage of the progress
  numberOfSteps: number;
}) => {
  return (
    <ProgressBarContainer>
      <ProgressBar style={{ width: `${progress}%` }}>
        {Array.from({ length: numberOfSteps }).map((_, i) => (
          <ProgressBlob
            key={i}
            $position={i}
            $isFilled={(i / (numberOfSteps - 1)) * 100 <= progress}
            $numberOfSteps={numberOfSteps}
          ></ProgressBlob>
        ))}
      </ProgressBar>
    </ProgressBarContainer>
  );
};

export default ProgressBarDynamicLesson;

const ProgressBarContainer = styled.div`
  position: absolute;
  width: 50%;
  max-width: 500px;
  margin: 0 auto;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${theme.colors.greyLight};
  height: 5px;
  border-radius: 5px;
  box-shadow: ${theme.effects.floatingCreatorElementShadow};
`;

const ProgressBar = styled.div`
  background-color: ${theme.colors.primary};
  height: 100%;
  border-radius: 5px;
  transition: width 0.5s ease;
`;

const ProgressBlob = styled.div<{
  $position: number;
  $numberOfSteps: number;
  $isFilled: boolean;
}>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ $isFilled }) =>
    $isFilled ? theme.colors.primary : theme.colors.greyLight};
  position: absolute;
  top: -8.5px;
  left: calc(
    ${({ $position, $numberOfSteps }) => `${($position / ($numberOfSteps - 1)) * 100}%`} -
      3px
  );
  transition: background-color 0.5s ease;
  box-shadow: ${theme.effects.floatingCreatorElementShadow};
`;
